module.exports = __webpack_public_path__ + "static/media/Thermometer Icon.7d34125e.jpeg";